//@flow
import {
  GetCloudCredentialsForTransferResponse,
  GetCloudCredentialsForTransferQuery,
  GetCloudCredentialsForTransferMessage
} from '../../autogenerated/ZoomBridge';

export default class GetCloudCredentialsForTransfer{
    _message: GetCloudCredentialsForTransferMessage;

    constructor() {}

    /**
    * @private
    */
    _doRun(): Promise<GetCloudCredentialsForTransferResponse> {
        const query: GetCloudCredentialsForTransferQuery = new GetCloudCredentialsForTransferQuery();
        const message = this._message;
        query.message = message;
        return query.run();
    }

    run(): Promise<GetCloudCredentialsForTransferResponse> {
        return this._doRun();
    }

}